<template>
  <div class="com">
    <div class="txt">
      4-digit verification code sent,
      <template v-if='this.field === "email"'>
       please check email.
      </template>
      <template v-else>
       please check SMS.
      </template><br/><span class="verification-item">{{
        item
      }}</span>
    </div>
    <div class="inputs-wrap">
      <input
        v-validate="'required'"
        type="number"
        class="input-item"
        name="input0"
        :value="input0"
        @input="checkInput"
        :disabled="disabled"
        :class="{ error: error }"
      />
      <input
        v-validate="'required'"
        type="number"
        class="input-item"
        name="input1"
        :value="input1"
        :disabled="disabled"
        :class="{ error: error }"
        @input="checkInput"
      />
      <input
        v-validate="'required'"
        type="number"
        class="input-item"
        @input="checkInput"
        :value="input2"
        :disabled="disabled"
        :class="{ error: error }"
        name="input2"
      />
      <input
        :value="input3"
        v-validate="'required'"
        type="number"
        class="input-item"
        :disabled="disabled"
        :class="{ error: error }"
        @input="checkInput"
        name="input3"
      />
    </div>
    <span v-if="errorMessage" class="errorMessage">{{ errorMessage }}</span>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
export default {
  name: "CodeNumber",
  props: ["field", "profile", "item","email"],
  data() {
    return {
      disabled: false,
      code: "",
      error: false,
      input0: "",
      input1: "",
      input2: "",
      input3: "",
      errorMessage: ""
    };
  },
  methods: {
    ...mapActions(["sendVerifyCode", "sendVerifyCodeProfile"]),
    ...mapMutations(["updateUserInfo"]),
    checkInput(e) {
      e.target.value = e.target.value ? e.target.value.replace(/\D/g, "") : "";
      if (e.inputType === "insertFromPaste" && e.target.value !== "") {
        let str = e.target.value.split("");
        str.forEach((item, i) => {
          let model = `input${i}`;
          this[model] = item;
          this.code += item;
        });
      }

      if (e.target.value && e.inputType !== "insertFromPaste") {
        e.target.value = e.target.value.split("").pop();
        this[e.target.name] = e.target.value;
      }

      if (e.target.value === "") {
        e.target.previousElementSibling &&
          e.target.previousElementSibling.focus();
      } else {
        e.target.nextElementSibling && e.target.nextElementSibling.focus();
      }
      this.code = this.input0 + this.input1 + this.input2 + this.input3;
    },
    sendData(e) {
      this.disabled = true;
      const data = {};
      const contacts = this.$store.getters.contacts;
      if (this.field === "phone") {
        data.phone = contacts.phone;
        data.confirmation_phone_code = this.code;
      } else {
        data.email = this.email;
        data.confirmation_email_code = this.code;
      }
      if (this.profile === "true") {
        this.sendVerifyCodeProfile(data)
          .then(res => {
            this.input0 = "";
            this.input1 = "";
            this.input2 = "";
            this.input3 = null;
            this.error = false;
            this.code = "";
            this.disabled = false;
            this.updateUserInfo(res.data.data.user);
            this.$emit("nextStep", { field: this.field, step: 1 ,emailCode:res.data.data.user.confirmation_email_code,phoneCode:res.data.data.user.confirmation_phone_code });
          })
          .catch(res => {
            this.$emit("valError", { error: res.response.data});
            this.error = true;
            this.disabled = false;
            this.code = "";
          });
      } else {
        this.sendVerifyCode(data)
          .then(res => {
            this.input0 = "";
            this.input1 = "";
            this.input2 = "";
            this.input3 = "";
            this.error = false;
            this.code = "";
            this.disabled = false;
            this.$emit("verified", { emailVerfied:res.data.data.user.confirmed_email,phoneVerfied:res.data.data.user.confirmed_phone });
            this.$emit("nextStep", { field: this.field, step: 1 });
          })
          .catch(res => {
            this.$emit("valError", { error: res.response.data});
            this.errorMessage = res.response.data.message;
            this.error = true;
            this.disabled = false;
            this.code = "";
          });
      }
    }
  },
  computed: {
    ...mapGetters(["serverValidation"])
  },
  serverValidation(error) {
    error.forEach(item => {
      this.$validator.errors.add({ field: item.field, msg: item.message });
    });
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";
.com {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}
.inputs-wrap {
  display: flex;
  justify-content: space-between;
  margin: 0 0 10px 0;
}
.errorMessage {
  color: $red;
  font-size: 12px;
  text-align: center;
  margin: 0 auto;
  font-family: TTNormsLight, sans-serif;
}
.input-item {
  width: 60px;
  height: 60px;
  padding: 13px 0;
  margin: 0 4px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 18px;
  border-radius: 5px;
  font-family: TTNormsLight, sans-serif;
}
.input-item.error {
  border: 1px solid $red;
}
.input-item::-webkit-outer-spin-button,
.input-item::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}
.txt {
  padding: 20px 0;
  text-align: center;
  font-family: TTNormsRegular, sans-serif;
  font-size: 15px;
  color: $gray;
  line-height: 20px;
  .verification-item {
    font-family: TTNormsMedium, sans-serif;
  }
}
</style>
